import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DashboardService } from 'src/app/modules/service/dashboard.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-billing-status',
  templateUrl: './update-billing-status.component.html',
  styleUrls: ['./update-billing-status.component.scss']
})
export class UpdateBillingStatusComponent implements OnInit {

  statusOptions = ['PAID', 'UNPAID', 'OVERDUE', 'PENDING'];
  currentUser: any;
  isLoading = false;

  statusForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private service: DashboardService,
    public dialogRef: MatDialogRef<UpdateBillingStatusComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.statusForm = this.fb.group({
      payment_status: new FormControl(data.payment_status, Validators.required),
      notes: new FormControl('')
    });
  }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('userdata'));
  }

  getStatusClass(status: string): string {
    switch ((status || '').toUpperCase()) {
      case 'PAID':    return 'status-paid';
      case 'UNPAID':  return 'status-unpaid';
      case 'OVERDUE': return 'status-overdue';
      case 'PENDING': return 'status-pending';
      default:        return '';
    }
  }

  saveStatus() {
    if (this.statusForm.invalid) return;

    const newStatus = this.statusForm.value.payment_status;
    const notes     = this.statusForm.value.notes;

    const payload = {
      invoice_no:     this.data.invoice_no,
      policy_no:      this.data.policy_no,
      payment_status: newStatus,
      modified_by:    this.currentUser ? this.currentUser.email : '',
      notes:          notes
    };

    this.isLoading = true;
    Swal.showLoading();

    this.service.updateBillingStatus(payload).subscribe(
      (res: any) => {
        this.isLoading = false;
        Swal.close();

        if (res && res.responseCode === '000') {
          Swal.fire({ icon: 'success', title: 'Updated', text: 'Billing status updated successfully.' });
          this.dialogRef.close({ event: 'updated', payment_status: newStatus });
        } else {
          Swal.fire({ icon: 'warning', title: 'Oops...', text: res ? res.responseMessage : 'Update failed.' });
        }
      },
      (err) => {
        this.isLoading = false;
        Swal.close();
        console.error(err);
        Swal.fire({ icon: 'error', title: 'Error', text: 'Could not update status. Please try again.' });
      }
    );
  }

  cancel() {
    this.dialogRef.close({ event: 'cancelled' });
  }
}
